module.exports = __webpack_public_path__ + "img/pic-03.7fb9e9c8.jpg";